import { render, staticRenderFns } from "./FaltantesMapa.vue?vue&type=template&id=78c1253c"
import script from "./FaltantesMapa.vue?vue&type=script&lang=js"
export * from "./FaltantesMapa.vue?vue&type=script&lang=js"
import style0 from "./FaltantesMapa.vue?vue&type=style&index=0&id=78c1253c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports